<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border w-full my-0 mx-auto">
      <div class="flex flex-row m-2 sm:m-4 text-base sm:text-lg gap-2 sm:gap-4 items-center flex-wrap">
        <div class="flex flex-row items-center gap-1.5 sm:gap-2">
          <div class="w-10 sm:w-14 h-3 sm:h-4 rounded-lg bg-[var(--color-orange)] shrink-0"></div>
          <label class="text-sm sm:text-base">{{ $t('Mindset360Display.open') }}</label>
        </div>
        <div class="flex flex-row items-center gap-1.5 sm:gap-2">
          <div class="w-10 sm:w-14 h-3 sm:h-4 rounded-lg bg-[var(--color-light-grey)] shrink-0"></div>
          <label class="text-sm sm:text-base">{{ $t('Mindset360Display.submitted') }}</label>
        </div>
      </div>
      <div class="relative mx-2 sm:mx-4 mb-4" id="task_card_container">
        <template v-if="allExternalEvaluations && allExternalEvaluations.length > 0">
          <mindset360-card-component v-for="mindset in allExternalEvaluations" :mindset="mindset"
            :key="mindset.seriesId"/>
        </template>
        <div v-else class="py-6 text-center items-center">
          <h2 class="text-gray-700 mb-2 text-lg sm:text-xl">
            {{ $t('Mindset360Display.noExternalEvaluations', { text: featureName }) }}
          </h2>
          <p class="text-gray-500 text-sm sm:text-base">
            {{ $t('Mindset360Display.noExternalEvaluationsMessage', { text: featureName }) }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <provide-feedback-component></provide-feedback-component>
</template>
<script>
import Mindset360CardComponent from './Mindset360CardComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'Mindset360Component',
  components: {
    Mindset360CardComponent,
    ProvideFeedbackComponent,
  },
  data() {
    return {
      searchbar: '',
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'externalEvaluation',
        this.$t('FallbackTexts.externalEvaluation'),
        this.$i18n?.locale,
      );
    },
    allExternalEvaluations() {
      return this.$store.getters.getExternalEvaluations;
    },
  },
  mounted() {
    this.$store.dispatch('getExternalEvaluation').then(() => {}).catch((e) => { console.log(e); });
  },
};
</script>
